// Which build this is, on every page. spec/04 §1.
//
// Two versions rather than one, because there are two things running and they
// can differ: a browser holding a cached bundle, a rollback that moved one and
// not the other, a CDN serving yesterday's assets. A single number would hide
// exactly the state that most needs seeing, so this says what the page is and
// what it is talking to, side by side.

import { useEffect, useState, type ReactElement } from 'react';
import { readApiRelease, type Release } from './api.ts';

declare const __WEB_RELEASE__: string;
declare const __WEB_BUILT_AT__: string;

export function Version(): ReactElement {
  const [api, setApi] = useState<Release | null>(null);
  const [unreachable, setUnreachable] = useState(false);

  useEffect(() => {
    let live = true;
    readApiRelease()
      .then((release) => {
        if (live) setApi(release);
      })
      .catch(() => {
        // Said out loud rather than left blank. "The API version is missing"
        // and "the API did not answer" look identical in a footer that simply
        // renders nothing, and only one of them is a problem.
        if (live) setUnreachable(true);
      });
    return () => {
      live = false;
    };
  }, []);

  return (
    <footer className="version">
      <p className="muted">
        <span title={`built ${__WEB_BUILT_AT__}`}>web {__WEB_RELEASE__}</span>
        {' · '}
        {unreachable ? (
          <span>api unreachable</span>
        ) : api === null ? (
          <span>api …</span>
        ) : (
          <span title={api.builtAt === null ? undefined : `built ${api.builtAt}`}>
            api {api.commit}
          </span>
        )}
      </p>
    </footer>
  );
}
